export const formatHoursRounded = (
    value: number | string | undefined,
    mode: "floor" | "ceil" = "floor"
  ): string => {
    if (value === undefined || value === null || value === "") return "0.00";

    const num = typeof value === "string" ? parseFloat(value) : value;
    const factor = 100;
  
    let result =
      mode === "ceil"
        ? Math.ceil(num * factor) / factor
        : Math.floor(num * factor) / factor;
  
    return result.toFixed(2);
  };
  